import { tKey } from 'ember-intl';
import {
  CATEGORIES,
  type Category,
  type FilterId,
  SUB_CATEGORIES,
  type SubCategory,
} from 'lumen/utils/constants/transaction-mapping/constants';

export const CATEGORY_TRANSLATIONS: Record<Category, string> = {
  [CATEGORIES.ROOMS]: tKey('settings.transaction_mapping.categories.rooms'),
  [CATEGORIES.FOOD_BEVERAGE]: tKey(
    'settings.transaction_mapping.categories.food_beverage',
  ),
  [CATEGORIES.RETAIL]: tKey('settings.transaction_mapping.categories.retail'),
  [CATEGORIES.CATERING_EVENTS]: tKey(
    'settings.transaction_mapping.categories.catering_events',
  ),
  [CATEGORIES.PARKING]: tKey('settings.transaction_mapping.categories.parking'),
  [CATEGORIES.SPA_WELLNESS]: tKey(
    'settings.transaction_mapping.categories.spa_wellness',
  ),
  [CATEGORIES.GOLF]: tKey('settings.transaction_mapping.categories.golf'),
  [CATEGORIES.PACKAGE]: tKey('settings.transaction_mapping.categories.package'),
  [CATEGORIES.OTHER]: tKey('settings.transaction_mapping.categories.other'),
  [CATEGORIES.FEES]: tKey('settings.transaction_mapping.categories.fees'),
  [CATEGORIES.NON_REVENUE]: tKey(
    'settings.transaction_mapping.categories.non_revenue',
  ),
  [CATEGORIES.UNMAPPED]: tKey('general.unmapped'),
};

export const SUB_CATEGORY_TRANSLATIONS: Record<SubCategory, string> = {
  [SUB_CATEGORIES.BANQUET_EVENT_SPACE]: tKey(
    'settings.transaction_mapping.sub_categories.banquet_event_space',
  ),
  [SUB_CATEGORIES.EQUIPMENT_AV]: tKey(
    'settings.transaction_mapping.sub_categories.equipment_av',
  ),
  [SUB_CATEGORIES.CATERING_EVENTS_FEES_MISC]: tKey(
    'settings.transaction_mapping.sub_categories.catering_events_fees_misc',
  ),
  [SUB_CATEGORIES.CATERING_EVENTS_FOOD_BEVERAGE]: tKey(
    'settings.transaction_mapping.sub_categories.catering_events_food_beverage',
  ),
  [SUB_CATEGORIES.CATERING_EVENTS_LABOR]: tKey(
    'settings.transaction_mapping.sub_categories.catering_events_labor',
  ),
  [SUB_CATEGORIES.CATERING_EVENTS_MEETING_ROOM_SPACE]: tKey(
    'settings.transaction_mapping.sub_categories.catering_events_meeting_room_space',
  ),
  [SUB_CATEGORIES.CANCELLATION]: tKey(
    'settings.transaction_mapping.sub_categories.cancellation',
  ),
  [SUB_CATEGORIES.PENALTIES]: tKey(
    'settings.transaction_mapping.sub_categories.penalties',
  ),
  [SUB_CATEGORIES.RESORT_FEE]: tKey(
    'settings.transaction_mapping.sub_categories.resort_fee',
  ),
  [SUB_CATEGORIES.SPECIAL_EVENTS]: tKey(
    'settings.transaction_mapping.sub_categories.special_events',
  ),
  [SUB_CATEGORIES.BAR]: tKey('settings.transaction_mapping.sub_categories.bar'),
  [SUB_CATEGORIES.BREAKFAST]: tKey(
    'settings.transaction_mapping.sub_categories.breakfast',
  ),
  [SUB_CATEGORIES.CAFE_COFFEE_BAR]: tKey(
    'settings.transaction_mapping.sub_categories.cafe_coffee_bar',
  ),
  [SUB_CATEGORIES.IN_ROOM_DINING]: tKey(
    'settings.transaction_mapping.sub_categories.in_room_dining',
  ),
  [SUB_CATEGORIES.MINIBAR]: tKey(
    'settings.transaction_mapping.sub_categories.minibar',
  ),
  [SUB_CATEGORIES.OTHER_FOOD_BEVERAGE]: tKey(
    'settings.transaction_mapping.sub_categories.other_food_beverage',
  ),
  [SUB_CATEGORIES.RESTAURANT]: tKey(
    'settings.transaction_mapping.sub_categories.restaurant',
  ),
  [SUB_CATEGORIES.GOLF]: tKey(
    'settings.transaction_mapping.sub_categories.golf',
  ),
  [SUB_CATEGORIES.NON_REVENUE_OTHER]: tKey(
    'settings.transaction_mapping.sub_categories.non_revenue_other',
  ),
  [SUB_CATEGORIES.NON_REVENUE_TAXES]: tKey(
    'settings.transaction_mapping.sub_categories.non_revenue_taxes',
  ),
  [SUB_CATEGORIES.NON_REVENUE_TIPS_GRATUITIES]: tKey(
    'settings.transaction_mapping.sub_categories.non_revenue_tips_gratuities',
  ),
  [SUB_CATEGORIES.OTHER_EQUIPMENT]: tKey(
    'settings.transaction_mapping.sub_categories.other_equipment',
  ),
  [SUB_CATEGORIES.OTHER_FAX_PHONE]: tKey(
    'settings.transaction_mapping.sub_categories.other_fax_phone',
  ),
  [SUB_CATEGORIES.OTHER_INTERNET]: tKey(
    'settings.transaction_mapping.sub_categories.other_internet',
  ),
  [SUB_CATEGORIES.OTHER_LAUNDRY_DRY_CLEANING]: tKey(
    'settings.transaction_mapping.sub_categories.other_laundry_dry_cleaning',
  ),
  [SUB_CATEGORIES.OTHER_OTHER]: tKey(
    'settings.transaction_mapping.sub_categories.other_other',
  ),
  [SUB_CATEGORIES.OTHER_TRANSPORTATION]: tKey(
    'settings.transaction_mapping.sub_categories.other_transportation',
  ),
  [SUB_CATEGORIES.PACKAGE]: tKey(
    'settings.transaction_mapping.sub_categories.package',
  ),
  [SUB_CATEGORIES.PARKING_DAY]: tKey(
    'settings.transaction_mapping.sub_categories.parking_day',
  ),
  [SUB_CATEGORIES.PARKING_OVERNIGHT]: tKey(
    'settings.transaction_mapping.sub_categories.parking_overnight',
  ),
  [SUB_CATEGORIES.RETAIL_SHOP]: tKey(
    'settings.transaction_mapping.sub_categories.retail_shop',
  ),
  [SUB_CATEGORIES.RETAIL_VENDING]: tKey(
    'settings.transaction_mapping.sub_categories.retail_vending',
  ),
  [SUB_CATEGORIES.ROOMS_ACCOMMODATIONS]: tKey(
    'settings.transaction_mapping.sub_categories.rooms_accommodations',
  ),
  [SUB_CATEGORIES.ROOMS_FEES_MISC]: tKey(
    'settings.transaction_mapping.sub_categories.rooms_fees_misc',
  ),
  [SUB_CATEGORIES.ROOMS_REDEMPTIONS]: tKey(
    'settings.transaction_mapping.sub_categories.rooms_redemptions',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_BODY_MASSAGE_SAUNA_ETC]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_body_massage_sauna_etc',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_FACE]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_face',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_FITNESS_TRAINING]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_fitness_training',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_HAIR_MAKE_UP]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_hair_make_up',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_HANDS_FEET]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_hands_feet',
  ),
  [SUB_CATEGORIES.SPA_WELLNESS_OTHER]: tKey(
    'settings.transaction_mapping.sub_categories.spa_wellness_other',
  ),
  [SUB_CATEGORIES.UNMAPPED]: tKey('general.unmapped'),
};

export const FILTER_TRANSLATION_KEYS: Record<FilterId, string> = {
  transactionCode: 'settings.transaction_mapping.transaction_code',
  pmsDescription: 'general.description',
  hotelName: 'general.hotel',
};
